module.exports = __webpack_public_path__ + "static/media/iconic-land.ffeb907c.gif";